import axios from 'axios'

export const fetchDeliveryOptionsRequest = ({ cartId, deliveryAddress }) => {
  return axios.post(`${window.booqableOptions?.apiURL ?? ''}/delivery_options`, {
    cart_id: cartId,
    delivery: {
      address: deliveryAddress
    },
    skip_checkout_validation: true,
    skip_shortage_validation: true
  })
}
